//
// Entity exports
module.exports.OfferUpdatePipeline = require('./offer-update-pipeline');